import React, { useRef } from "react";
import { toast } from "react-toastify";
import config from "../../../config";
const IntegrationConfirmDetails = ({ details, onButtonClick }) => {
  const urlRef = useRef(null);

  const handleCopyToClipboard = () => {
    if (urlRef.current) {
      const url = urlRef.current.textContent;
      navigator.clipboard.writeText(url)
        .then(() => {
          toast.success('URL copied to clipboard!');
        })
        .catch((err) => {
          toast.error('Failed to copy URL to clipboard.');
          console.error('Failed to copy URL to clipboard:', err);
        });
    }
  };

  // Generate the GUID when the component mounts

  return (
    <div className="mb-6 rounded-md border bg-white p-4 px-4 shadow-lg">

      <div className="text-sm">
        <div className="text-gray-600">
          <div className="text-lg font-medium">Integration Details</div>
          <div>Save the below details that are important to trigger</div>
        </div>
      </div>

      <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-1.5">
        <div className="w-full sm:w-1/4 py-1 font-bold text-gray-700">Integration Name:</div>
        <div className="w-full sm:w-3/4 rounded-md bg-gray-100 p-3 sm:p-2 text-gray-900 shadow-inner">
          {details && details.name}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-1.5">
        <div className="w-full sm:w-1/4 py-1 font-bold text-gray-700">Description:</div>
        <div className="w-full sm:w-3/4 rounded-md bg-gray-100 p-3 sm:p-2 text-gray-900 shadow-inner">
          {details && details.description}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-1.5">
        <div className="w-full sm:w-1/4 py-1 font-bold text-gray-700">Url:</div>
        <div className="flex w-full sm:w-3/4 items-center justify-between break-words rounded-md bg-gray-100 p-3 sm:p-2 text-gray-900 shadow-inner overflow-hidden">
          <div ref={urlRef} className="truncate mr-4 font-mono text-[11px] sm:text-xs text-blue-600">
            {`${config.API_BASE_URL}/api/integrations/execute/${details && details.integration_id}/`}
          </div>
          <button
            onClick={handleCopyToClipboard}
            className="flex-shrink-0 rounded-md bg-blue-600 px-3 py-1 text-xs font-bold text-white transition-colors duration-200 hover:bg-blue-700 shadow-sm"
          >
            Copy
          </button>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-1.5">
        <div className="w-full sm:w-1/4 py-1 font-bold text-gray-700">Http Method:</div>
        <div className="w-full sm:w-3/4 rounded-md bg-gray-100 p-3 sm:p-2 text-gray-900 shadow-inner">
          {details && details.triggerDetails && details.triggerDetails.triggerHttpMethod}
        </div>
      </div>

      {/* <div className="flex py-1">
        <div className="w-1/5 py-2 font-bold">Authorization:</div>
        <div className="w-2/5 whitespace-pre-wrap break-words rounded-md bg-gray-100 p-2">
        Bearer {bearerToken}
        </div>
      </div> */}
    </div>
  );
};

export default IntegrationConfirmDetails;
